import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import marginPositionStatesSubscritionService from '../../services/subscriptions/marginPositionStatesSubscriptionService';
import marginPositionPaymentsSubscriptionService from '../../services/subscriptions/marginPositionPaymentsSubscriptionService';
import { showSnack } from './snackbarActions';
import { marginAccountSelector } from '../selectors/marginSelectors';
import { POSITION_STATUSES } from '../../constants/marginConstants';
export var REQUEST_OPEN_POSITIONS = 'REQUEST_OPEN_POSITIONS';
export var REQUEST_CLOSED_POSITIONS = 'REQUEST_CLOSED_POSITIONS';
export var REQUEST_MARGIN_POSITIONS_PAYMENTS = 'REQUEST_MARGIN_POSITIONS_PAYMENTS';
export var RECEIVE_OPEN_POSITIONS = 'RECEIVE_OPEN_POSITIONS';
export var RECEIVE_CLOSED_POSITIONS = 'RECEIVE_CLOSED_POSITIONS';
export var ADD_OPEN_POSITION = 'ADD_OPEN_POSITION';
export var ADD_CLOSED_POSITION = 'ADD_CLOSED_POSITION';
export var RECEIVE_MARGIN_POSITIONS_PAYMENTS = 'RECEIVE_MARGIN_POSITIONS_PAYMENTS';
export var REMOVE_MARGIN_HISTORY_ACTIVE_REQUEST = 'REMOVE_MARGIN_HISTORY_ACTIVE_REQUEST';
export var RECEIVE_MARGIN_POSITION_PAYMENTS_EVENT = 'RECEIVE_MARGIN_POSITION_PAYMENTS_EVENT';
export var getOpenPositions = function getOpenPositions(AccountId, OMSId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var positions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch(requestOpenPositions());
              _context.next = 4;
              return dispatch(callAPI('GetMarginPositionStates', {
                omsId: OMSId,
                accountId: AccountId,
                status: POSITION_STATUSES.NotClose
              }));
            case 4:
              positions = _context.sent;
              if (positions.length === 0 || positions.length > 0) {
                dispatch(receiveOpenPositions(positions));
              } else {
                dispatch(removeMarginHistoryActiveRequest());
                console.error('GetMarginPositionStates error: ', positions.errormsg);
              }
              _context.next = 12;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context['catch'](0);
              dispatch(removeMarginHistoryActiveRequest());
              console.error('GetMarginPositionStates error: ', _context.t0);
            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var getClosedPositions = function getClosedPositions(AccountId, OMSId) {
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var positions;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              dispatch(requestClosedPositions());
              _context2.next = 4;
              return dispatch(callAPI('GetMarginPositionStates', {
                omsId: OMSId,
                accountId: AccountId,
                status: POSITION_STATUSES.Close
              }));
            case 4:
              positions = _context2.sent;
              if (positions.length === 0 || positions.length > 0) {
                dispatch(receiveClosedPositions(positions));
              } else {
                dispatch(removeMarginHistoryActiveRequest());
                console.error('GetMarginPositionStates error: ', positions.errormsg);
              }
              _context2.next = 12;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);
              dispatch(removeMarginHistoryActiveRequest());
              console.error('GetMarginPositionStates error: ', _context2.t0);
            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var getMarginPositionPayments = function getMarginPositionPayments(AccountId, OMSId) {
  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var positions;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              dispatch(requestMarginPositionPayments());
              _context3.next = 4;
              return dispatch(callAPI('GetMarginPositionPayments', {
                omsId: OMSId,
                accountId: AccountId
              }));
            case 4:
              positions = _context3.sent;
              if (positions.length === 0 || positions.length > 0) {
                dispatch(receiveMarginPositionsPayments(positions));
              } else {
                dispatch(removeMarginHistoryActiveRequest());
                console.error('GetMarginPositionPayments error: ', positions.errormsg);
              }
              _context3.next = 12;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3['catch'](0);
              dispatch(removeMarginHistoryActiveRequest());
              console.error('GetMarginPositionPayments error: ', _context3.t0);
            case 12:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8]]);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var removeMarginHistoryActiveRequest = function removeMarginHistoryActiveRequest() {
  return {
    type: REMOVE_MARGIN_HISTORY_ACTIVE_REQUEST
  };
};
export var subscribeToMarginPositionStates = function subscribeToMarginPositionStates(AccountId, OMSId) {
  return function (dispatch) {
    marginPositionStatesSubscritionService.subscribe(function (updates) {
      if (updates.AccountId === AccountId) {
        dispatch(receiveMarginPositionState(updates));
      }
    });
  };
};
export var subscribeToMarginPositionPayments = function subscribeToMarginPositionPayments() {
  return function (dispatch) {
    marginPositionPaymentsSubscriptionService.subscribe(function (updates) {
      dispatch(receiveMarginPositionPaymentsEvent(updates));
    });
  };
};
export var receiveMarginPositionPaymentsEvent = function receiveMarginPositionPaymentsEvent(updates) {
  return {
    type: RECEIVE_MARGIN_POSITION_PAYMENTS_EVENT,
    payload: updates
  };
};
export var receiveMarginPositionState = function receiveMarginPositionState(updates) {
  return function (dispatch) {
    if (updates.Status === 'Open' || updates.Status === 'InClosing') {
      dispatch(addOpenPosition(updates));
    } else if (updates.Status === 'Close') {
      dispatch(addClosedPosition(updates));
    } else {
      // console.error('unsupported marginPosition status'); // InClosingWithSettlementOnly.
    }
  };
};
export var addOpenPosition = function addOpenPosition(payload) {
  return {
    type: ADD_OPEN_POSITION,
    payload: payload
  };
};
export var addClosedPosition = function addClosedPosition(payload) {
  return {
    type: ADD_CLOSED_POSITION,
    payload: payload
  };
};
export var requestOpenPositions = function requestOpenPositions() {
  return {
    type: REQUEST_OPEN_POSITIONS
  };
};
export var requestClosedPositions = function requestClosedPositions() {
  return {
    type: REQUEST_CLOSED_POSITIONS
  };
};
export var requestMarginPositionPayments = function requestMarginPositionPayments() {
  return {
    type: REQUEST_MARGIN_POSITIONS_PAYMENTS
  };
};
export var receiveOpenPositions = function receiveOpenPositions(payload) {
  return {
    type: RECEIVE_OPEN_POSITIONS,
    payload: payload
  };
};
export var receiveClosedPositions = function receiveClosedPositions(payload) {
  return {
    type: RECEIVE_CLOSED_POSITIONS,
    payload: payload
  };
};
export var receiveMarginPositionsPayments = function receiveMarginPositionsPayments(payload) {
  return {
    type: RECEIVE_MARGIN_POSITIONS_PAYMENTS,
    payload: payload
  };
};
export var closeMarginPosition = function closeMarginPosition(_ref4, CloseType) {
  var AccountId = _ref4.AccountId,
    PositionId = _ref4.PositionId,
    InstrumentId = _ref4.InstrumentId,
    OMSId = _ref4.OMSId;
  return function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch(callAPI('CloseMarginPosition', {
                OMSId: OMSId,
                AccountId: AccountId,
                CloseType: CloseType,
                InstrumentId: InstrumentId
              })).then(function (res) {
                if (res.result) {
                  dispatch(getOpenPositions(AccountId, OMSId));
                  dispatch(showSnack({
                    id: 'cancelOpenPositionsSuccessSnack',
                    text: 'Position ' + PositionId + ' closed',
                    type: 'success'
                  }));
                } else {
                  dispatch(showSnack({
                    id: 'cancelOpenPositionsErrorSnack',
                    text: res.errormsg + ': ' + res.detail,
                    type: 'warning'
                  }));
                }
              });
            case 2:
              return _context4.abrupt('return', _context4.sent);
            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));
    return function (_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var GetEstimatedAmountForClosePositionBySettlement = function GetEstimatedAmountForClosePositionBySettlement(OrderId, InstrumentId) {
  return function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var OMSId, _marginAccountSelecto, AccountId;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId;
              _marginAccountSelecto = marginAccountSelector(getState()), AccountId = _marginAccountSelecto.AccountId;
              _context5.next = 4;
              return dispatch(callAPI('GetEstimatedAmountForClosePositionBySettlement', {
                OMSId: OMSId,
                AccountId: AccountId,
                OrderId: OrderId,
                InstrumentId: InstrumentId
              }));
            case 4:
              return _context5.abrupt('return', _context5.sent);
            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};